module.exports = __webpack_public_path__ + "assets/images/incomplete-assignments-icon.91fe72b41ea772829726e24cb0e751c1.svg";